import { render, staticRenderFns } from "./dockSummaryView2.vue?vue&type=template&id=2d6b7c96&scoped=true"
import script from "./dockSummaryView2.vue?vue&type=script&lang=js"
export * from "./dockSummaryView2.vue?vue&type=script&lang=js"
import style0 from "./dockSummaryView2.vue?vue&type=style&index=0&id=2d6b7c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b7c96",
  null
  
)

export default component.exports